import { createReducer } from '@reduxjs/toolkit';
import { GET_TERMINALS } from '../actions/terminals';

type Terminal = unknown;

export type TerminalState = {
  terminals: Terminal[];
};

const initState: TerminalState = {
  terminals: [],
};

const terminalReducer = createReducer(initState, (builder) =>
  builder.addCase(GET_TERMINALS, (state, action) => {
    return { ...state, terminals: action.payload };
  })
);

export default terminalReducer;
